import { updatePassword, signInWithEmailAndPassword } from "firebase/auth"

import { auth } from "./auth"

export const changePassword = (
  currentPassword: string,
  newPassword: string,
) => {
  const user = auth.currentUser
  if (!user) {
    throw new Error("ログインしてください")
  }
  if (!user.email) {
    throw new Error("ログイン中のアカウントのメールアドレスが無効です")
  }
  return signInWithEmailAndPassword(auth, user.email, currentPassword).then(
    () => updatePassword(user, newPassword),
  )
}
